import script from "./MdKontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MdKontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./MdKontraktorPage.vue?vue&type=style&index=0&id=edf48314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edf48314"]])

export default __exports__